<template>
  <v-layout class="flex-grow-overwrite-all announcement-image-uploader">
    <v-flex class="announcement-image-uploader__main">
      <v-radio-group v-model="selectedType" hide-details mandatory reaquired
                     @change="handleTypeChange"
                     class="announcement-image-uploader__main--selectors">
        <div>
          <v-radio :value="createChapterStudioConstant.ANNOUNCEMENT_IMAGE_TYPE.IMAGE"
                   :label="createChapterStudioConstant.ANNOUNCEMENT_IMAGE_TYPE.IMAGE"
                   :color="createChapterStudioConstant.RADIO_COLOR"
                   class="mb-3 announcement-image-uploader__radio">
          </v-radio>
        </div>
        <div>
          <v-radio :value="createChapterStudioConstant.ANNOUNCEMENT_IMAGE_TYPE.BACKGROUND_COLOR"
                   :label="createChapterStudioConstant.ANNOUNCEMENT_IMAGE_TYPE.BACKGROUND_COLOR"
                   :color="createChapterStudioConstant.RADIO_COLOR"
                   class="mb-3 announcement-image-uploader__radio">
          </v-radio>
        </div>
      </v-radio-group>
      <div class="announcement-image-uploader__selector">
        <div v-if="isImageUploadSelected">
          <div class="announcement-image-uploader__image-selector-title">
            <span class="announcement-image-uploader__image-selector-title--main">
              {{createChapterStudioConstant.FORM_FIELD.SELECT_IMAGE_TITLE}}
            </span>
            <span class="announcement-image-uploader__image-selector-title--sub">
              {{createChapterStudioConstant.FORM_FIELD.SELECT_IMAGE_TITLE_SUB}}
            </span>
          </div>
          <div class="announcement-image-uploader__image-selector-guidance">
            {{createChapterStudioConstant.FORM_FIELD.SELECT_IMAGE_GUIDANCE}}
          </div>
          <v-layout row class="flex-grow-overwrite-all announcement-image-uploader__upload-btn">
            <v-flex><photo-uploader :upload-callback="handleImageUpload"
                                    uploader-id="photo-upload-btn"
                                    extensions="jpg,jpeg,png"
                                    accept="image/png, image/jpeg"
                                    :hide-error="true"
                                    :multiple="false"
                                    :maximum-files="1"
                                    :button-label="createChapterStudioConstant.ACTION.UPLOAD">
            </photo-uploader></v-flex>
            <v-flex class="announcement-image-uploader__image-url">{{imageUrl}}</v-flex>
          </v-layout>
        </div>
        <div v-if="isBackgroundSelected">
          <div class="announcement-image-uploader__image-selector-title">
            <span class="announcement-image-uploader__image-selector-title--main">
              {{createChapterStudioConstant.FORM_FIELD.SELECT_BACKGROUND_TITLE}}
            </span>
            <span class="announcement-image-uploader__image-selector-title--sub">
              {{createChapterStudioConstant.FORM_FIELD.SELECT_IMAGE_TITLE_SUB}}
            </span>
          </div>
          <v-layout row class="flex-grow-overwrite-all" v-if="backgroundColorOptions.length">
            <div :class="[
                'announcement-image-uploader__background-option',
                isSelectedBackgroundColor(bColor) && 'announcement-image-uploader__background-option--selected'
                ]"
                 @click="handleBackgroundColorSelection(bColor)"
                 v-for="bColor in backgroundColorOptions"
                 :style="{backgroundColor: bColor}"
                 :key="bColor"></div>
          </v-layout>
        </div>
      </div>
    </v-flex>
    <v-flex class="announcement-image-uploader__preview" v-if="imageUrl && isImageUploadSelected">
      <YpoImageWithLoader
          class="announcement-image-uploader__preview--img"
          data-qe-id="announcement-image-upload__preview"
          :image-url="imageUrl">
      </YpoImageWithLoader>
    </v-flex>
  </v-layout>
</template>

<script>
import { createChapterStudioConstant } from "@/components/ChapterStudioPageManage/manageChapterStudio.constant";
import PhotoUploader from "@/components/PhotoUploader/PhotoUploader.vue";
import { mapGetters } from "vuex";
import { storeGetters } from "@/store/storeGetters.constant";
import YpoImageWithLoader from "@/components/YpoImageWithLoader/YpoImageWithLoader.vue";

export default {
  name: 'CreateAnnouncementImageUploader',
  components: { YpoImageWithLoader, PhotoUploader },
  data() {
    return {
      createChapterStudioConstant,
      selectedType: createChapterStudioConstant.ANNOUNCEMENT_IMAGE_TYPE.IMAGE,
      imageFiles: [],
      selectedBackgroundColor: null,
    };
  },
  props: {
    backgroundColor: {
      type: String,
    },
    backgroundImage: {
      type: String,
    },
  },
  async created() {
    this.selectedType = this.backgroundColor && this.backgroundColor.length
        ? createChapterStudioConstant.ANNOUNCEMENT_IMAGE_TYPE.BACKGROUND_COLOR
        : createChapterStudioConstant.ANNOUNCEMENT_IMAGE_TYPE.IMAGE;

    if (this.backgroundColor && this.backgroundColor.length) {
      this.selectedBackgroundColor = `${this.backgroundColor}`;
    }
  },
  methods: {
    handleTypeChange() {
      if (this.selectedType === createChapterStudioConstant.ANNOUNCEMENT_IMAGE_TYPE.BACKGROUND_COLOR && this.selectedBackgroundColor) {
        this.sendUpdatedData(null, null, this.selectedBackgroundColor);
      } else if (this.selectedType === createChapterStudioConstant.ANNOUNCEMENT_IMAGE_TYPE.IMAGE) {
        if (this.imageFiles.length) {
          this.sendUpdatedData(this.imageFiles, null, null);
        } else {
          this.sendUpdatedData(this.backgroundImage || null, null, null);
        }
      }
    },
    handleImageUpload(files) {
      this.imageFiles = files;
      this.sendUpdatedData(files, this.imageUrl, null);
    },
    isSelectedBackgroundColor(bColor) {
      return this.selectedBackgroundColor === bColor;
    },
    handleBackgroundColorSelection(bColor) {
      this.selectedBackgroundColor = bColor;
      this.sendUpdatedData(null, null, bColor);
    },
    sendUpdatedData(imageFile, imageUrl, bColor) {
      this.$emit('imageBackgroundData', {
        files: imageFile,
        backgroundImage: imageUrl,
        backgroundColor: bColor,
      });
    },
  },
  computed: {
    ...mapGetters({
      chapterStudioPicklists: `manageChapterStudio/${storeGetters.chapterStudioPicklists}`,
    }),
    isImageUploadSelected() {
      return this.selectedType === this.createChapterStudioConstant.ANNOUNCEMENT_IMAGE_TYPE.IMAGE;
    },
    isBackgroundSelected() {
      return this.selectedType === this.createChapterStudioConstant.ANNOUNCEMENT_IMAGE_TYPE.BACKGROUND_COLOR;
    },
    imageUrl() {
      if (this.imageFiles.length && this.imageFiles[0].url) {
        return this.imageFiles[0].url;
      } else if (this.backgroundImage && this.backgroundImage.length) {
        return this.backgroundImage;
      }
      return null;
    },
    backgroundColorOptions() {
      return this.chapterStudioPicklists && this.chapterStudioPicklists.backgroundColors
          ? this.chapterStudioPicklists.backgroundColors
          : [];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";
@import "../../common/styles/_commonClasses.scss";

.announcement-image-uploader {
  padding-top: 16px;

  @include breakpointMin(sm) {
    padding-top: 24px;
  }

  &__main {
    min-width: 350px;

    &--selectors {
      margin-left: 25px;
      @include breakpointMin(sm) {
        margin-left: 0;
      }
    }
  }

  &__image-selector-title {
    color: $ypo-blue;
    font-weight: 600;
    padding-bottom: 3px;

    @include breakpointMin(sm) {
      padding-bottom: 12px;
    }

    &--main {
      font-size: 18px;
      padding-right: 2px;

      @include breakpointMin(sm) {
        padding-right: 5px;
      }
    }

    &--sub {
      font-size: 12px;
    }
  }

  &__image-selector-guidance {
    font-size: 12px;
    font-weight: 500;
    color: $ypo-title-blue-gray
  }

  &__background-option {
    height: 50px;
    width: 105px;
    margin-right: 12px;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      border: 2px solid $ypo-light-gold;
    }

    &--selected {
      border: 2px solid $ypo-light-gold;
    }
  }

  &__preview {
    padding-left: 10px;
    display: none;

    @include breakpointMin(sm) {
      display: block;
    }

    &--img {
      height: 184px;
      width: 280px;
      border-radius: 8px;
    }
  }

  &__image-url {
    font-size: 11px;
    padding-left: 15px;
    height: 32px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;

    @include breakpointMin(sm) {
      display: none;
    }
  }
}
</style>


<style lang="scss">
@import "../../common/styles/_colors.scss";

.announcement-image-uploader {
  &__radio {
    .v-label {
      font-size: 14px !important;
    }
  }

  .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
  }

  &__upload-btn {
    margin-top: 5px;

    .photo-uploader {
      width: 120px;

      &__btn {
        margin-top: 0;
        font-size: 16px;
        border-radius: 8px;
        width: 120px;
        height: 32px;
        background-color: $ypo-brand-blue;
        font-weight: 600;
        cursor: pointer !important;

        &-label {
          text-transform: uppercase;
          padding: 0;
          color: $white;
        }

        &:hover {
          background-color: $ypo-primary-blue !important;
        }
      }
    }
  }

}
</style>

